import PrimeXCoverageDetails from '../../../../../agencies/quotes/PrimeX/quoteDetails/components/PrimeXCoverageDetails';
import type { Category } from '../../../../../workflows/quotes/prime-x/api/types/rater-x-preset';
import { COUNTRY_MAPPING } from '../../../../../../i18n/i18n.language-config';
import { getPlatformRegion } from '../../../../../../utils';
import type { GetPrimeXPolicyDetailsByViewResponse } from '../../../../../../api/policies.api.types';
import useMergeRaterXCoverages from '../../../../../agencies/quotes/PrimeX/quoteDetails/hooks/useMergeRaterXCoverages';

interface IPolicyCoverageDetailsResolver {
  policyDetails: GetPrimeXPolicyDetailsByViewResponse;
}

const PolicyCoverageDetailsResolver = ({
  policyDetails,
}: IPolicyCoverageDetailsResolver) => {
  const language =
    COUNTRY_MAPPING[
      policyDetails?.policy?.firmographicData
        ?.country as keyof typeof COUNTRY_MAPPING
    ] ?? getPlatformRegion();

  const mergedRaterXCoverages = useMergeRaterXCoverages({
    coverageCategories:
      policyDetails?.policy?.raterResponse?.coverageCategories ?? [],
    fieldValues: policyDetails?.dynamicFields ?? [],
  });

  return (
    <PrimeXCoverageDetails
      coverageByCategories={
        mergedRaterXCoverages.coverageCategories as Category[]
      }
      language={language}
      containerStyle={{ mt: 2 }}
    />
  );
};

export default PolicyCoverageDetailsResolver;
